import { render, staticRenderFns } from "./ContractSuppliersReport.vue?vue&type=template&id=651963e2&scoped=true&"
import script from "./ContractSuppliersReport.vue?vue&type=script&lang=js&"
export * from "./ContractSuppliersReport.vue?vue&type=script&lang=js&"
import style0 from "./ContractSuppliersReport.vue?vue&type=style&index=0&id=651963e2&prod&lang=sass&scoped=true&"
import style1 from "./ContractSuppliersReport.vue?vue&type=style&index=1&id=651963e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651963e2",
  null
  
)

export default component.exports